import AlertasCategoriasForm from "./AlertasCategoriasForm";
export default AlertasCategoriasForm;
